import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconEducational: React.FC<IconProps> = ({ width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
        >
            <g clip-path="url(#clip0_5355_14095)">
                <path
                    d="M18.7288 25.4997C14.9955 25.4997 11.958 22.4622 11.958 18.7288C11.958 14.9955 14.9955 11.958 18.7288 11.958C22.4622 11.958 25.4997 14.9955 25.4997 18.7288C25.4997 22.4622 22.4622 25.4997 18.7288 25.4997ZM18.7288 12.9997C15.5695 12.9997 12.9997 15.5695 12.9997 18.7288C12.9997 21.8882 15.5695 24.458 18.7288 24.458C21.8882 24.458 24.458 21.8882 24.458 18.7288C24.458 15.5695 21.8882 12.9997 18.7288 12.9997Z"
                    fill="black"
                />
                <path
                    d="M18.7288 22.3753C18.4413 22.3753 18.208 22.142 18.208 21.8545V17.6878C18.208 17.4003 18.4413 17.167 18.7288 17.167C19.0163 17.167 19.2497 17.4003 19.2497 17.6878V21.8545C19.2497 22.142 19.0163 22.3753 18.7288 22.3753Z"
                    fill="black"
                />
                <path
                    d="M18.7288 16.1247C19.0165 16.1247 19.2497 15.8915 19.2497 15.6038C19.2497 15.3162 19.0165 15.083 18.7288 15.083C18.4412 15.083 18.208 15.3162 18.208 15.6038C18.208 15.8915 18.4412 16.1247 18.7288 16.1247Z"
                    fill="black"
                />
                <path
                    d="M9.70729 16.6977C9.63021 16.6977 9.55208 16.68 9.47708 16.6446C8.19792 16.0144 6.81979 15.7769 5.37917 15.9342C4.92917 15.9873 4.47708 15.8457 4.14062 15.5457C3.81354 15.254 3.625 14.8352 3.625 14.3957V2.15608C3.625 1.37691 4.20729 0.707118 4.97917 0.598784C7.46667 0.231076 9.81458 0.922743 11.9583 2.66337C14.1021 0.923784 16.4469 0.228993 18.9406 0.599826C19.7094 0.707118 20.2917 1.37691 20.2917 2.15608V9.35399C20.2917 9.64149 20.0583 9.87483 19.7708 9.87483C19.4833 9.87483 19.25 9.64149 19.25 9.35399V2.15608C19.25 1.89358 19.0531 1.66649 18.7917 1.63003C16.4458 1.28108 14.3229 1.9717 12.301 3.73628C12.1052 3.90712 11.8125 3.90712 11.6167 3.73628C9.59271 1.97066 7.47188 1.28108 5.12812 1.62899C4.86354 1.66649 4.66667 1.89253 4.66667 2.15608V14.3957C4.66667 14.5405 4.72604 14.6727 4.83333 14.7675C4.94792 14.8696 5.10104 14.9175 5.2625 14.8988C6.90417 14.7165 8.47708 14.9894 9.93854 15.7092C10.1969 15.8363 10.3021 16.1488 10.176 16.4071C10.0844 16.5905 9.9 16.6977 9.70729 16.6977Z"
                    fill="black"
                />
                <path
                    d="M22.8958 10.9163C22.6083 10.9163 22.375 10.683 22.375 10.3955V4.14551C22.375 3.85801 22.1417 3.62467 21.8542 3.62467H19.7708C19.4833 3.62467 19.25 3.39134 19.25 3.10384C19.25 2.81634 19.4833 2.58301 19.7708 2.58301H21.8542C22.7156 2.58301 23.4167 3.28405 23.4167 4.14551V10.3955C23.4167 10.683 23.1833 10.9163 22.8958 10.9163Z"
                    fill="black"
                />
                <path
                    d="M9.35417 18.208H2.0625C1.20104 18.208 0.5 17.507 0.5 16.6455V4.14551C0.5 3.29967 1.19687 2.59863 2.05313 2.58301H4.14583C4.43333 2.58301 4.66667 2.81634 4.66667 3.10384C4.66667 3.39134 4.43333 3.62467 4.14583 3.62467H2.0625C1.78021 3.62988 1.54167 3.86322 1.54167 4.14551V16.6455C1.54167 16.933 1.775 17.1663 2.0625 17.1663H9.35417C9.64167 17.1663 9.875 17.3997 9.875 17.6872C9.875 17.9747 9.64167 18.208 9.35417 18.208Z"
                    fill="black"
                />
                <path
                    d="M11.9583 12.9997C11.6708 12.9997 11.4375 12.7663 11.4375 12.4788V3.10384C11.4375 2.81634 11.6708 2.58301 11.9583 2.58301C12.2458 2.58301 12.4792 2.81634 12.4792 3.10384V12.4788C12.4792 12.7663 12.2458 12.9997 11.9583 12.9997Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_5355_14095">
                    <rect width="25" height="25" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEducational;
